export enum SubmissionStatus {
    'CREATED' = 'CREATED',
    'PROCESSING' = 'PROCESSING',
    'COMPLETE' = 'COMPLETE',
    'ERROR' = 'ERROR',
    'INIT' = 'INIT',
}

export enum SubmissionErrorType {
    UNSUPPORTED_FILETYPE = 'UNSUPPORTED_FILETYPE',
    PROCESSING_ERROR = 'PROCESSING_ERROR',
    CANNOT_EXTRACT_TEXT = 'CANNOT_EXTRACT_TEXT',
    TOO_LITTLE_TEXT = 'TOO_LITTLE_TEXT',
    TOO_MUCH_TEXT = 'TOO_MUCH_TEXT',
    TOO_MANY_PAGES = 'TOO_MANY_PAGES',
    FILE_LOCKED = 'FILE_LOCKED',
    CORRUPT_FILE = 'CORRUPT_FILE',
}
